import React from 'react'
import { Row, Col, Space, Input, Select, InputNumber, Typography } from 'antd'
const { Option } = Select
import '../../../index.css'

const { Text } = Typography

const AcDetails = (props) => {
  return (
    <div className=''>
      <Row justify='flex-start' gutter={[48, 0]} className='ac-details'
      >
        <Col xs={24} md={18} className='grey-bkg'>
          <Row gutter={[24, 24]} className='h-100'>
            <Col xs={24} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <div className='WB-tiles'>
                <Text className='tile-header'>Ship #</Text>
                <div className='tile-data'>
                  <Input
                    bordered={false}
                    name='ship'
                    value={props.ship}
                    onChange={props.onChange}
                    disabled={props.ccPlanModalVisible}
                    onBlur={props.onSubmit}
                  />
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <div className='WB-tiles'>
                <Text className= 'tile-header'>DOM/INTL</Text>
                <div className='tile-data'>
                  <Select
                    allowClear
                    size='small'
                    placeholder='DOM/INTL'
                    bordered={false}
                    className='w-100'
                    value={props.type}
                    disabled={props.ccPlanModalVisible}
                    onChange={(v) => props.onChange({
                      target: {
                        name: 'type',
                        value: v
                      } 
                    })}
                  >
                    <Option value='Domestic'>Domestic </Option>
                    <Option value='International'>International</Option>
                  </Select>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
              <Space.Compact align='stretch ' className='WB-tiles pax-counts-tile'>
                <div className= 'tile-header f-middle pax-count-title'>Expected <br /> Pax Counts</div>
                <Space.Compact block direction='horizontal' className='pax-counts-inputs'>
                  <Space.Compact block direction='vertical'>
                    <div className='tile-horiz-header'>C</div>
                    <div className='tile-data'>
                      <InputNumber
                        type= 'number'
                        size= 'small'
                        bordered= {false}
                        // min= {1}
                        // max={}
                        controls= {false}
                        disabled={props.ccPlanModalVisible}
                        value={props.pax?.c}
                        onChange={(v) => props.onChangePax({
                          target: {
                            name: 'c',
                            value: v
                          } 
                        })}
                      /></div>
                  </Space.Compact>
                  <Space.Compact block direction='vertical'>
                    <div className='tile-horiz-header'>F</div>
                    <div className='tile-data'>
                      <InputNumber
                        type= 'number'
                        size= 'small'
                        bordered= {false}
                        // min= {1}
                        // max={}
                        controls= {false}
                        value={props.pax?.f}
                        disabled={props.ccPlanModalVisible}
                        onChange={(v) => props.onChangePax({
                          target: {
                            name: 'f',
                            value: v
                          } 
                        })}
                      /></div>
                  </Space.Compact>
                  <Space.Compact block direction='vertical'>
                    <div className='tile-horiz-header'>W</div>
                    <div className='tile-data'>
                      <InputNumber  
                        type= 'number'
                        size= 'small' 
                        bordered= {false}
                        // min= {1}
                        // max={}
                        controls= {false}
                        value={props.pax?.w}
                        disabled={props.ccPlanModalVisible}
                        onChange={(v) => props.onChangePax({
                          target: {
                            name: 'w',
                            value: v
                          } 
                        })}                      
                      /></div>
                  </Space.Compact>
                  <Space.Compact block direction='vertical' className='pax-subtitle'>
                    <div className='tile-horiz-header'>Y</div>
                    <div className='tile-data'>
                      <InputNumber  
                        type= 'number'
                        size= 'small' 
                        bordered= {false}
                        // min= {1}
                        // max={}
                        controls= {false}
                        value={props.pax?.y}
                        disabled={props.ccPlanModalVisible}
                        onChange={(v) => props.onChangePax({
                          target: {
                            name: 'y',
                            value: v
                          } 
                        })}
                      /></div>
                  </Space.Compact>
                </Space.Compact>
              </Space.Compact>
            </Col>
            <Col xs={24} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <div className='WB-tiles'>
                <Text className='tile-header'>Exp.Fuel(lbs)</Text>
                <div className='tile-data'>
                  <InputNumber  
                    type= 'number'
                    size= 'small' 
                    bordered= {false}
                    // min= {1}
                    // max={}
                    controls= {false}
                    // value={props.fuel}
                    // kg to lbs conversion
                    value={props.fuel !== null && props.fuel !== undefined ? Math.round(props.fuel * 2.20462) : null}
                    disabled={props.ccPlanModalVisible}
                    onChange={(v) => props.onChange({
                      target: {
                        name: 'fuel',
                        // lbs to kg conversion
                        value: v !== null && v !== undefined ? v / 2.20462 : null
                      } 
                    })}
                  /></div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <div className='WB-tiles'>
                <Text className='tile-header'>Season</Text>
                <div className='tile-data'>                    
                  <Select
                    allowClear
                    size='small'
                    placeholder='Season'
                    bordered={false}
                    className='w-100'
                    value={props.season}
                    disabled={props.ccPlanModalVisible}
                    onChange={(v) => props.onChange({
                      target: {
                        name: 'season',
                        value: v
                      } 
                    })}
                  >
                    <Option value='Summer'>Summer</Option>
                    <Option value='Winter'>Winter</Option>
                  </Select>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={24} md={6} className='blue-bkg'>
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={12} md={24} lg={24} xl={12} xxl={12}>
              <div className='WB-tiles'>
                <Text className= 'tile-header'>Cargo Margin</Text>
                <p className='tile-data'>{props.cargo_margin !== null && props.cargo_margin !== undefined ? parseFloat(props.cargo_margin).toFixed(2) : ''}</p>
              </div>
            </Col>
            <Col xs={24} sm={12} md={24} lg={24} xl={12} xxl={12}>
              <div className='WB-tiles'>
                <Text className='tile-header'>Aft Index</Text>
                <div style={props.aftIndexStyle(props.aft_index)} className='tile-data'>
                  <div>{props.aft_index? props.aft_index : props.wgt_bal_status}</div>
                  {props.fleet == '763' && props.aft_index && (props.aft_index > 81 && props.aft_index < 10000) ? (
                    <div className='add-text'>Tail Heavy</div>
                  ) : null}
                  {props.fleet == '763' && props.aft_index && (props.aft_index < 19) ? (
                    <div className='add-text'>Nose Heavy</div>
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
export default AcDetails
